export default __webpack_public_path__ + "static/media/icon_home_inactive_new.b628ed04.svg";